module.exports = __webpack_public_path__ + "img/spinner-red.11b3db20.svg";